import { render, staticRenderFns } from "./CompletedAccountRegistration.vue?vue&type=template&id=ce7bf5ee&scoped=true&"
import script from "./CompletedAccountRegistration.vue?vue&type=script&lang=js&"
export * from "./CompletedAccountRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CompletedAccountRegistration.vue?vue&type=style&index=0&id=ce7bf5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7bf5ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})
